'use client'

import { useRouter } from 'next/navigation'
import { TransitionStartFunction } from 'react'

import { CLASSNAME_CONTAINED_CONTENT } from '../../../../../../../app/App.constants'
import { cn } from '../../../../../../../lib/utils'
import type { Locale } from '../../../../../../../localization/i18n'

import AdditionalFilters from './components/AdditionalFilters'
import DateFilter from './components/DateFilter'
import TimeFilter from './components/TimeFilter'

interface Props {
  startTransition: TransitionStartFunction
  locale: Locale
}

const Filters = ({ startTransition, locale }: Props) => {
  const router = useRouter()

  const handleRouteChange = (newRoute: string) =>
    startTransition(() => {
      router.replace(newRoute)
    })

  return (
    <div className={cn(CLASSNAME_CONTAINED_CONTENT, 'flex gap-1 px-1 py-2 sm:gap-2')}>
      <DateFilter handleRouteChange={handleRouteChange} locale={locale} />
      <TimeFilter handleRouteChange={handleRouteChange} />
      <AdditionalFilters handleRouteChange={handleRouteChange} />
    </div>
  )
}
export default Filters
